import React from 'react';
import { VerticalTimeline } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../../assets/styles/Timeline.scss';
import { useTranslation } from 'react-i18next';
import TimelineElement from './TimelineElement';
import { JOBS } from './constants';
import { usePageTitle } from '../../hooks/usePageTitle';

function Timeline() {
  const { t } = useTranslation();
  usePageTitle('Expériences');

  return (
    <section className="experience-section">
      <div className="experience-header">
        <h1>{t('Expériences')}</h1>
        <div className="experience-rule" />
      </div>
      <VerticalTimeline>
        {JOBS.map((job, index) => (
          <TimelineElement key={index} job={job} />
        ))}
      </VerticalTimeline>
    </section>
  );
}

export default Timeline;
